import React, { useState } from "react";
import "./NavBar.css";

import Logo from "../../assets/image/RibatProLogo.png";
import { useTranslation } from "react-i18next";

import { FlagIcon } from "react-flag-kit";

const ITFlag = () => <FlagIcon code="IT" size={18} />;
const FRFlag = () => <FlagIcon code="FR" size={18} />;
const UKFlag = () => <FlagIcon code="GB" size={18} />;

const NavBar = () => {

  const [t, i18n] = useTranslation("global");

  const [language, setLanguage] = useState("en");

  const [menuOpen, setMenuOpen] = useState(false);

  const handelLanguageChange = (lang) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbarContainer">

        {/* Logo */}
        <div className="logo">
          <a href="#Hero" onClick={closeMenu}>
            <img src={Logo} alt="Ribat Logo" className="logoImage" />
          </a>
        </div>


        <div className="menuIcon" onClick={toggleMenu}>
          ☰
        </div>


        <div className="navItemsContainer">
          <ul className={menuOpen ? "navList active" : "navList"}>
            <li className="navItem">
              <a href="#Hero" onClick={closeMenu}>
                {t("navBar.home")}
              </a>
            </li>

            <li className="navItem">
              <a href="#About" onClick={closeMenu}>
                {t("navBar.about")}
              </a>
            </li>

            <li className="navItem">
              <a href="#Service" onClick={closeMenu}>
                {t("navBar.service")}
              </a>
            </li>

            <li className="navItem">
              <a href="#Products" onClick={closeMenu}>
                {t("navBar.product")}
              </a>
            </li>
          </ul>
        </div>

        <div className="langContainer">

          {language === "en" ? null : (
            <button className="flag" onClick={() => handelLanguageChange("en")}>
              <UKFlag />
            </button>
          )}

          {language === "fr" ? null : (
            <button className="flag" onClick={() => handelLanguageChange("fr")}>
              <FRFlag />
            </button>
          )}

          {language === "it" ? null : (
            <button className="flag" onClick={() => handelLanguageChange("it")}>
              <ITFlag />
            </button>
          )}

        </div>

        <a href={`mailto:${t("footer.email")}`}>
          <button className="ContactBtn">
            {t("navBar.contact")}
          </button>
        </a>

      </div>
    </nav>
  );
};

export default NavBar;